
import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { TimeMeasure } from "../../../../utilities";
import { ModelEditableMixin, DisableableMixin } from "../../mixins";

@Component({
})
export default class SelectableMixin extends Mixins(ModelEditableMixin, DisableableMixin) {
  @Prop()
  options: any[];

  @Prop()
  equivalentValidator: (s: any, d: any) => boolean;

  @Prop()
  filter: (source: any) => boolean;

  get optionFilter(): (source: any) => boolean {
    return o => !this.filter || this.filter(o);
  }

  get filteredOptions(): any[] {
    return TimeMeasure.log(
      "選択肢絞込み",
      () => Enumerable.from(this.options)
        .where(this.optionFilter)
        .toArray(),
      "",
      TimeMeasure.off // 調査必要な時に出力するよう設定する事.
    );
  }

  areEqual(source: any, destination: any): boolean {
    return !this.equivalentValidator
      ? (source === destination)
      : this.equivalentValidator(source, destination);
  }

  findOption(source: any, options: any[]): any {
    return Enumerable.from(!options ? [] : options)
      .firstOrDefault(o => this.areEqual(o, source));
  }
}
